import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';
import { FontAwesomeIcon, KeyboardAwareScrollView } from '../modules';
import APIClient from '../utils/APIClient';
import Utils from '../utils/Utils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class CreateAgencyScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes, params} = navigation.state;
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <FontAwesomeIcon
            name='plus-circle'
            size={32}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      title: 'Đăng kí đại lý',
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      email: '',
      phone: '',
      name: '',
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {email, phone, name} = this.state;
    let errorMessage, inputRefName;
    if (_.isEmpty(email)) {
      errorMessage = 'Vui lòng điền địa chỉ email';
      inputRefName = 'emailTextInput';
    } else if (!Utils.isEmailValid(email)) {
      errorMessage = 'Địa chỉ email không hợp lệ';
      inputRefName = 'emailTextInput';
    } else if (_.isEmpty(phone)) {
      errorMessage = 'Vui lòng điền số điện thoại';
      inputRefName = 'phoneTextInput';
    } else if (!Utils.isPhoneValid(phone)) {
      errorMessage = 'Số điện thoại không hợp lệ';
      inputRefName = 'phoneTextInput';
    } else if (_.isEmpty(name)) {
      errorMessage = 'Vui lòng điền tên đại lý';
      inputRefName = 'nameTextInput';
    }

    if (errorMessage) {
      if (Platform.OS === 'web') {
        alert(errorMessage);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          errorMessage,
          [
            {text: 'OK', onPress: () => this._focusTextInput(inputRefName)},
          ],
        );
      }
      return;
    }

    this.setState({
      submitting: true,
    });

    const data = {
      email,
      phone,
      name,
    };
    const {response, error} = await APIClient.POST('/partner/agency', data);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }

    this.setState({
      submitting: false,
    });

    let message;
    if (response && response.response) {
      message = Utils.parseSuccessMessage(response,
        'Đăng kí đại lý thành công');
    } else {
      message = Utils.parseErrorMessage(response, error,
        'Đăng kí đại lý thất bại, vui lòng thử lại sau');
    }

    if (Platform.OS === 'web') {
      alert(message);
    } else {
      Alert.alert(
        global.__APP_NAME__,
        message,
      );
    }
  }

  render () {
    const {email, phone, name, submitting} = this.state;
    return (
      <KeyboardAwareScrollView
        automaticallyAdjustContentInsets={false}
        keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
        keyboardShouldPersistTaps='always'
        containerContentStyle={styles.contentContainer}
        style={styles.container}>

        <Text
          style={[
            styles.inputTitleText, {
              marginTop: 24,
            }]}>
          Địa chỉ email
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='emailTextInput'
            value={email}
            placeholder='Địa chỉ email'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='email-address'
            autoCapitalize='none'
            returnKeyType='next'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('email', text)}
            onSubmitEditing={() => this._focusTextInput('phoneTextInput')}/>
        </View>

        <Text
          style={styles.inputTitleText}>
          Số điện thoại
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='phoneTextInput'
            value={phone}
            placeholder='Số điện thoại'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='numeric'
            autoCapitalize='none'
            returnKeyType='next'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('phone', text)}
            onSubmitEditing={() => this._focusTextInput('nameTextInput')}/>
        </View>

        <Text
          style={styles.inputTitleText}>
          Họ và tên
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='nameTextInput'
            value={name}
            placeholder='Họ và tên'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            autoCapitalize='words'
            returnKeyType='go'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('name', text)}
            onSubmitEditing={this._submit}/>
        </View>

        <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._submit}
          style={styles.submit}>
          <Image
            source={require('../img/btn.png')}
            style={styles.submitImage}/>
          <Text
            style={styles.submitText}>
            ĐĂNG KÍ
          </Text>
          {submitting && <View
            style={styles.submitting}>
            <ActivityIndicator
              animating
              color='#ffffff'
              style={styles.submittingIndicator}/>
          </View>}
        </TouchableOpacity>

      </KeyboardAwareScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

// export default connect(mapStateToProps, mapDispatchToProps)(CreateAgencyScreen);
export default CreateAgencyScreen;



// WEBPACK FOOTER //
// ./src/partner/CreateAgencyScreen.js